import React from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

interface TriStateCircleProps {
  state: 'none' | 'some' | 'all';
  size?: number;
}

const TriStateCircle: React.FC<TriStateCircleProps> = ({ state, size = 24 }) => {
  let icon = null;
  switch (state) {
    case 'all':
      icon = <CheckCircleIcon style={{ fontSize: size, color: '#4caf50' }} />;
      break;
    case 'some':
      icon = <RemoveCircleOutlineIcon style={{ fontSize: size, color: '#ff9800' }} />;
      break;
    case 'none':
    default:
      icon = <RadioButtonUncheckedIcon style={{ fontSize: size, color: '#bdbdbd' }} />;
      break;
  }
  return (
    <Box display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        mr: '4px',
      }}>
      {icon}
    </Box >
  );
};

export default TriStateCircle;
